import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrashcan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M3.33333 13.3333C3.33333 13.6869 3.47381 14.0261 3.72386 14.2761C3.97391 14.5262 4.31304 14.6666 4.66667 14.6666H11.3333C11.687 14.6666 12.0261 14.5262 12.2761 14.2761C12.5262 14.0261 12.6667 13.6869 12.6667 13.3333V5.33331H14V3.99998H11.3333V2.66665C11.3333 2.31302 11.1929 1.97389 10.9428 1.72384C10.6928 1.47379 10.3536 1.33331 10 1.33331H6C5.64638 1.33331 5.30724 1.47379 5.05719 1.72384C4.80714 1.97389 4.66667 2.31302 4.66667 2.66665V3.99998H2V5.33331H3.33333V13.3333ZM6 2.66665H10V3.99998H6V2.66665ZM5.33333 5.33331H11.3333V13.3333H4.66667V5.33331H5.33333Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6 6.66669H7.33333V12H6V6.66669ZM8.66667 6.66669H10V12H8.66667V6.66669Z",
		fill: "currentColor"
	})]
});
export default SvgTrashcan;
